import { Link } from "react-router-dom";
import type { Drama } from "@/types/drama";

interface RankListProps {
  items: Drama[];
}

export default function RankList({ items }: RankListProps) {
  return (
    <ol className="grid gap-2 md:grid-cols-2 md:gap-x-4">
      {items.map((drama, index) => (
        <li key={drama.id}>
          <Link
            to={`/detail/${drama.id}`}
            className="group flex items-center gap-3 rounded-lg border border-transparent px-2 py-2 transition-colors hover:border-background-200 hover:bg-background-50"
          >
            <span
              className={`w-6 shrink-0 text-center font-heading text-lg font-black ${
                index < 3 ? "text-accent-600" : "text-foreground-300"
              }`}
            >
              {String(index + 1).padStart(2, "0")}
            </span>
            <span className="h-14 w-10 shrink-0 overflow-hidden rounded bg-primary-900">
              <img
                src={drama.cover}
                alt={drama.title}
                title={`${drama.title} 高清电视剧在线观看`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block truncate text-sm font-medium text-foreground-900 group-hover:text-primary-600">
                {drama.title}
              </span>
              <span className="mt-0.5 block truncate text-[11px] text-foreground-500">
                {drama.genres.join(" · ")} · {drama.year}
              </span>
            </span>
            <span className="shrink-0 text-right">
              <span className="block text-xs font-semibold text-accent-600">{drama.rating.toFixed(1)}</span>
              <span className="mt-0.5 block text-[10px] text-foreground-400">{drama.views}</span>
            </span>
          </Link>
        </li>
      ))}
    </ol>
  );
}